import type { UseAuthStore } from '#src/state/AuthStore.ts';
import * as React from 'react';
import { createContext, use, useMemo } from 'react';

interface StoreContextType {
  useAuthStore: UseAuthStore;
}

const StoreContext = createContext<StoreContextType | undefined>(undefined);

export function StoreProvider({
  children,
  useAuthStore
}: React.PropsWithChildren<StoreContextType>) {
  const context = useMemo(() => ({ useAuthStore }), [useAuthStore]);
  return <StoreContext value={context}>{children}</StoreContext>;
}

export function useStores() {
  const context = use(StoreContext);

  if (!context) {
    throw new Error('useStores needs to be used inside <StoreProvider>');
  }

  return context;
}
